<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <div class="content">
      <board-one-item
        v-for="(item, index) in StoreList"
        :key="item.id"
        :storeItem="item"
        :storeIndex="index"
        :currentPage="currentPage"
        color="#FFC82B"
      ></board-one-item>
      <Spin size="large" v-if="isLoading" fix></Spin>
      <div
        v-if="!isLoading && (!StoreList || StoreList.length === 0)"
        class="no-data"
      >
        {{ $t('common.no_data') }}
      </div>
    </div>
    <div
      style="display: flex; justify-content: space-around; margin-top: 10px"
      class="bottom-item"
    >
      <!-- <Page
        :total="totalPage"
        :page-size="5"
        :current="currentPage"
        size="small"
        @on-change="getData"
      /> -->
    </div>
  </Card>
</template>
<script>
import boardOneItem from './boardOneItem.vue';
import api from '../../../api/home/index';
import moment from 'moment';
export default {
  components: {
    boardOneItem,
  },
  data() {
    return {
      totalPage: null,
      currentPage: 1,
      isLoading: true,
      timerPage: null, //切换分页定时器
      timerData: null, //请求数据定时器
      currentDataPage: 1,
      allData: [],
    };
  },
  computed: {
    StoreList() {
      if (this.currentPage === 1) {
        let arr = this.allData.slice(0, this.currentPage * 5);
        return this.filterData(arr);
      } else {
        let arr = this.allData.slice(
          (this.currentPage - 1) * 5,
          this.currentPage * 5
        );
        return this.filterData(arr);
      }
    },
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timerPage);
    clearInterval(this.timerData);
  },
  methods: {
    filterData(data) {
      let max = Math.max(...data.map(i => i.nowScore || 0));
      let content = data.map(i => {
        return {
          name: i.shopName,
          nowScore: (i.nowScore / max) * 100 || 0,
        };
      });
      return content;
    },
    // 分页
    getData() {
      this.isLoading = true;
      let startTime = moment()
        .month(moment().month())
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment()
        .month(moment().month())
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let params = {
        timeType: 3,
        startTime,
        endTime,
        order: 0,
        pageNumber: this.currentDataPage,
        pageSize: 70,
      };
      this.pageShopScore(params).then(() => {
        if (!this.timerPage) {
          this.timerPage = setInterval(() => {
            if (this.currentPage * 5 >= this.totalPage) {
              this.currentPage = 1;
            } else {
              this.currentPage++;
            }
          }, 5000);
        }
        if (!this.timerData) {
          this.timerData = setInterval(() => {
            if (this.currentDataPage * 70 >= this.totalPage) {
              clearInterval(this.timerData);
              return;
            } else {
              this.currentDataPage++;
            }
            this.getData();
          }, 60000);
        }
      });
    },
    async pageShopScore(param) {
      let newParam = {
        ...param,
      };
      await api
        .getShopRank(newParam)
        .then(data => {
          let max = Math.max(...data.records.map(i => i.averageShop || 0));
          let content = data.records.map(i => {
            return {
              name: i.shopName,
              nowScore: (i.averageShop / max) * 100 || 0,
            };
          });

          this.allData = [...this.allData, ...content];
          this.totalPage = data.total;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          clearInterval(this.timerPage);
          clearInterval(this.timerData);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
  .ivu-card-body{
    padding-top: 0;
    overflow-y: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}

.content {
  height: 200px;
  .rank-index {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
  }
  ::v-deep {
    .ivu-spin-fix {
      background: none !important;
    }
  }
}
.bottom-item {
  ::v-deep {
    .ivu-progress-outer {
      margin-top: 4px;
    }
    .ivu-page-prev {
      background: rgba(255, 255, 255, 0.1) !important;
    }
    .ivu-page-next {
      background: rgba(255, 255, 255, 0.1) !important;
    }
    .ivu-page-item {
      background: rgba(255, 255, 255, 0.1) !important;
    }
  }
}
</style>
